
import {decodeToken} from "../login/login/actions";

/**
 * Parse the commandline token and dispatch an action.
 *
 * @param component {React.Component}
 * @param params {Object}
 */
const handle_token_dispatch = (component, params) => {

  let username, wlf_id;

  // Login for the first time
  if (params.user_pass) {
    component.props.logout();
    decodeToken(params.user_pass)
      .then(result => {
        if (result.success) {
          // Strip off the leading wlf
          wlf_id = component.props.app.wlf.id;
          if (result.username.startsWith(wlf_id)) {
            username = result.username.substr(wlf_id.length + 1);
          } else {
            username = result.username;
          }

          component.setState({
            username,
            password: result.password,
          }, () => component.signInCb());

        } else {
          component.props.setError("Login token expired.");
        }
      });
  } else if (params.ugma_payment) {

    component.props.UGMALogin(
      component.props.app.wlf.id,
      params.ugma_payment
    );
  }
}

export { handle_token_dispatch };
